module.exports = __webpack_public_path__ + "img/159.0356233c.jpg";